import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportParamsComponent } from '../../../../../../../shared/tokens/report-params';

@Component({
  selector: 'adf-erection-supervision-and-startup-params',
  imports: [FormsModule],
  templateUrl: './erection-supervision-and-startup-params.component.html',
  styleUrls: ['./erection-supervision-and-startup-params.component.scss'],
})
export class ErectionSupervisionAndStartupParamsComponent implements ReportParamsComponent {
  variables: Record<string, unknown> = {
    IsWhThVisible: false,
  };
  selectionChanged?: (variables: Record<string, unknown>) => void;

  private _ctrlHeld = false;
  private _snapshot: Record<string, unknown> | null = null;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Control' && !this._ctrlHeld) {
      this._ctrlHeld = true;
      this._snapshot = { ...this.variables };
    }
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Control') {
      this._ctrlHeld = false;
      if (this._snapshot && this._hasChanged(this._snapshot)) {
        this.selectionChanged?.(this.variables);
      }
      this._snapshot = null;
    }
  }

  onCheckboxChange(): void {
    if (this._ctrlHeld) return;
    this.selectionChanged?.(this.variables);
  }

  private _hasChanged(snapshot: Record<string, unknown>): boolean {
    return Object.keys(this.variables).some((k) => this.variables[k] !== snapshot[k]);
  }
}
